<template>
  <div class="contentBox">
    <p class="title">
      {{title}}
    </p>
    <p class="text">
      {{text}}
    </p>
    <div v-html="txt"></div>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      txt:'',
      title:'',
      text:''
    };
  },
  components: {
    
  },
  watch: {
    $route() {
      console.log(this,'==this==')
      window.location.reload();
    }
  },
  mounted(){
    var type = this.$route.query.type;
    if(type == 1){
      this.title = 'Speakio Terms of Service';
      document.title = 'Speakio Terms of Service';
      this.text = 'Effective Date: April 26, 2026';
      this.txt = "Welcome to Speakio! These Terms of Service ('Terms') govern your access to and use of the Speakio mobile application and related services (collectively, the 'Service'), provided by Speakio2026 ('we,' 'us,' or 'our'). <br>\
 <br>\
                  <span class='blod'>1. Description of Service</span> Speakio is an AI-powered public speaking and communication coaching application. The Service includes, but is not limited to, AI-assisted script generation, practice modes, and multi-modal (visual, audio, textual) diagnostic analysis. We utilize third-party Large Language Model (LLM) APIs to provide these features. <br>\
 <br>\
                  <span class='blod'>2. Accounts and Subscriptions</span> Speakio is an AI-powered public speaking and communication coaching application. The Service includes, but is not limited to, AI-assisted script generation, practice modes, and multi-modal (visual, audio, textual) diagnostic analysis. We utilize third-party Large Language Model (LLM) APIs to provide these features. <br>\
 <br>\
                  Paid Subscriptions: Speakio offers premium features through auto-renewing subscriptions. All payments are securely processed through the Google Play Billing system.<br>\
 <br>\
                  Renewal and Cancellation: Your subscription will automatically renew unless auto-renew is turned off at least 24 hours before the end of the current period. You can manage and cancel your subscriptions at any time through your Google Play Account Settings.<br>\
 <br>\
                  <span class='blod'>3. Disclaimer of AI-Generated Content</span> The feedback, diagnostic reports, and scripts generated by our AI are for informational and practice purposes only. We do not guarantee the 100% accuracy, completeness, or reliability of the AI-generated content. We are not liable for any business losses, failed interviews, or other consequences arising from your reliance on the Service.<br>\
 <br>\
                  <span class='blod'>4. User Conduct</span> You agree not to use the Service to record, upload, or generate any content that is unlawful, defamatory, sexually explicit, violent, or infringes upon the intellectual property rights of others.<br>\
 <br>\
                  <span class='blod'>5. Intellectual Property</span> You retain full ownership of the original video and audio recordings you create within the app. Speakio only processes these files to the extent necessary to provide the AI diagnostic services requested by you.<br>\
 <br>\
                  "
    } else if(type == 2){
      this.title = 'Speakio Privacy Policy';
      document.title = 'Speakio Privacy Policy';
      this.text = 'Effective Date: April 26, 2026';
      this.txt = "We take your privacy seriously. This Privacy Policy explains how Speakio2026 collects, uses, and protects your information when you use the Speakio app.<br>\
<br>\
                  <span class='blod'>1. Information We Collect</span><br>\
<br>\
                  Account Information: Information provided during login (e.g., Email address, username via Google Sign-In).<br>\
<br>\
                  Camera and Microphone Data (Crucial): To provide our core AI diagnostic features, we require access to your device's camera and microphone. Camera and microphone permissions are accessed ONLY when you actively initiate a speaking practice session, and are strictly used for AI diagnostic analysis. We will NEVER listen in the background, record without your permission, or use this data for marketing purposes.<br>\
<br>\
                  Device and Usage Information: Device model, operating system version, unique device identifiers, and app usage logs (used for crash reporting and performance optimization).<br>\
<br>\
                  <span class='blod'>2. How We Use Your Information</span><br>\
<br>\
                  To Provide AI Diagnostics: We process your video, audio, and text data to generate speech analysis reports.<br>\
<br>\
                  Service Improvement: We may use anonymized, aggregated interaction data to optimize our prompt engineering and improve the user experience.<br>\
<br>\
                  <span class='blod'>3. Third-Party Data Sharing To deliver our core functionalities, we securely transmit specific data to trusted third-party service providers:</span><br>\
<br>\
                  AI API Providers: We utilize Tongyi Qianwen (通义千问) for our underlying AI model capabilities. Your practice data is sent to this provider via encrypted APIs strictly for analysis and report generation.br>\
<br>\
                  Payment Processors: Google Play Billing processes your payment information. We do not collect or store your credit card details.<br>\
<br>\
                  <span class='blod'>4. Data Storage and Retention</span><br>\
<br>\
                  Storage and Retention Policy: By default, your video, audio recordings, and diagnostic reports are stored permanently on our secure servers so you can review your historical progress at any time.<br>\
<br>\
                  User Control: You have full control over your data. You can manually delete any of your recordings and associated reports at any time directly within the app. Once manually deleted by you, the data will be permanently erased from our active servers.<br>\
<br>\
                  <span class='blod'>5. Your Privacy Rights Depending on your location, you have the right to access, correct, or request the deletion of your personal data. You can exercise these rights directly within the app settings or by contacting us at our support email.</span><br>\
<br>\
                  <span class='blod'>6. Children's Privacy Speakio is not intended for use by children under the age of 13 (or the applicable minimum age in your jurisdiction). We do not knowingly collect personal data from children.</span><br>\
<br>\
                  <span class='blod'>7. Contact Us If you have any questions about this Privacy Policy or your data, please contact us at: Email: zentimewise2@gmail.com</span><br>\
<br>\
                  "
    } else if(type == 3){
      this.title = '智能演讲教练会员服务协议';
      document.title = '智能演讲教练会员服务协议';
      this.text = '生效时间：2025-4 发布时间：2025-4';
      this.txt = "感谢您使用【智能演讲教练】会员增值服务，为使用【智能演讲教练】会员增值服务（简称为：本服务）， <br>\
                  您应当阅读并遵守《智能演讲教练会员服务协议》（简称为：本协议）。 <br>\
                  请您务必审慎阅读、充分理解各条款内容，特别是免除或限制责任等相应条款，以及开通或使用某项服务的单独协议，并选择接受或不接受。 <br>\
                  免除或限制责任条款可能以加粗形式提示您注意。 <br>\
                  未成年人应在法定监护人陪同下审阅和履行本协议，未成年人行使和履行本协议项下的权利和义务视为已获得法定监护人的认可。 <br>\
                  一、协议的范围<br>\
                  1.1 协议适用主体范围<br>\
                  本协议是您与智能演讲教练信息技术（上海）有限公司之间关于您使用本增值服务所订立的协议。<br>\
                  1.2 您同意本协议即视为您自愿接受并遵守智能演讲教练提供服务涉及的包括本协议在内的所有服务规范及相关协议、管理规范，包括但不限于智能演讲教练不时发布并修订的关于智能演讲教练服务协议、隐私政策、会员相关协议、活动规则、使用规则、公告、提示、通知等内容。<br>\
                  二、服务内容<br>\
                  2.1 会员增值服务，指您按照智能演讲教练的指定方式支付一定服务费用之后，可以享有由智能演讲教练提供的的特权服务，简称为：本服务。<br>\
                  2.2 智能演讲教练可能会根据不同的产品及服务类型，推出不同的会员增值服务，对现有会员增值服务种类、会员权益等进行调整以及不断推出新的会员增值服务种类。具体会员增值服务种类及服务内容以相关服务页面公布、实际提供的服务内容为准，并在公告后依法生效。您可以自行根据需要选择相应服务。<br>\
                  2.3 关于广告的特别说明：您在使用智能演讲教练会员服务的过程中，将接触到以各种方式投放的商业性广告或其他类型的商业信息，智能演讲教练会提供“免广告特权”,“免广告特权”的范围仅指在智能演讲教练中带有“广告”标识的内容，不含第三方信息资讯等内容。广告特权包括为您自动跳过广告，也可手动关闭内容推荐；但此权益可能因版权方限制或其他限制原因，仍可能会向您呈现不同种类的广告服务，且亦不排除智能演讲教练以其他方式投放的广告或商业信息。对此您理解并予以接受，您不追究并豁免智能演讲教练的相关责任，同时智能演讲教练承诺会尽量降低对您的使用体验影响。<br>\
                  三、会员费用及期限<br>\
                  3.1 费用标准及支付<br>\
                  3.1.1 本服务是智能演讲教练提供的收费服务，您须在按照本服务的收费标准支付相应费用后，方可使用本服务。<br>\
                  3.1.2 智能演讲教练可能会根据本服务的整体规划，对本服务的收费标准、方式等进行修改和变更，前述修改、变更，智能演讲教练将在相应服务页面进行展示。您若需要获取、使用本服务，请先提前了解清楚当时关于本服务的收费标准、方式等信息。您的开通以及支付行为视为您完全清楚智能演讲教练提供收费服务的收费标准以及方式。<br>\
                  3.1.3 您可以通过智能演讲教练指定的包括但不限于微信支付、支付宝、Apple Pay等现有方式、今后智能演讲教练指定方式在依约支付费用后开通本服务。<br>\
                  3.1.4 智能演讲教练在此声明，您支付后智能演讲教练不接受任何形式的退费请求，除非因智能演讲教练产品技术原因，导致您购买时被重复扣款或因智能演讲教练产品技术原因导致您无法享有购买的服务时，请您在7日内提出退款申诉，经过智能演讲教练核实后可为您办理退款，但您需要提供相应信息并配合智能演讲教练处理,如您未在前述约定期限提出申诉，智能演讲教练视为您购买产品/服务无任何问题。您理解并清楚接受上述条件，如您不接受的，请谨慎选择收费服务。<br>\
                  3.2 服务期限<br>\
                  3.2.1 本服务的服务期限以您自行选择并支付相应服务费用的期限为准，本服务现有包月、包半年、包年服务，您也可以登录智能演讲教练个人中心或者本服务的相应页面查询。会员服务的服务期限到期后，智能演讲教练将停止继续向您提供会员服务，服务期限届满前智能演讲教练可能会提醒您及时续费。<br>\
                  3.2.2 如您希望享受会员服务连续采购和自动扣费的服务，您可以根据操作指引向智能演讲教练提出申请，并在仔细阅读《智能演讲教练会员自动续费服务协议》后决定是否继续申请。<br>\
                  四、会员服务的开通、账号管理及注销<br>\
                  4.1 您通过智能演讲教练指定的方式依约支付费用后即开通本服务。本服务开通之后，仅限于您在智能演讲教练平台使用，不及于其他任何平台，未经智能演讲教练书面同意不可提供给任何第三方进行使用，包括但不限于赠与、出售、租用、借用、分享、受让等方式。<br>\
                  4.2 会员账号的管理<br>\
                  （1）您充分了解并同意，您须为自己登录账号下的行为负责，本账号下的一切行为均视为您本人的行为，包括但不限于您所发表的任何内容以及由此产生的后果，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。您应对本服务提供的内容自行加以判断，并承担因使用相关内容而引起的风险。<br>\
                  （2）您应正确使用及妥善保管、维护您的会员账号及密码，如发生泄露、遗失、被盗等行为，而该等行为并非智能演讲教练法定过错导致，损失将由您自行承担。<br>\
                  （3）会员服务仅限于申请账号自行使用；每个账号之间的充值记录、数据无法进行转移、迁徙、转让、赠与、售卖、租借、分享，无论该等账号是否由同一使用人拥有，请您在登录及/或参加活动时注意区分，避免造成损失。<br>\
                  4.3 账号的使用<br>\
                  您不得通过以下任何方式为自己或他人开通本服务：<br>\
                  （1）以营利、经营等非个人使用的目的为自己或他人开通本服务；<br>\
                  （2）通过任何机器人软件、蜘蛛软件、爬虫软件、刷屏软件等任何程序、软件方式为自己或他人开通本服务；<br>\
                  （3）通过任何不正当手段或以违反诚实信用原则的方式为自己或他人开通本服务；<br>\
                  （4）通过非智能演讲教练指定的方式开通本服务；<br>\
                  （5）通过侵犯智能演讲教练或他人合法权益的方式开通本服务；<br>\
                  （6）通过其他违反相关法律、行政法规、国家政策等的方式为自己或他人开通本服务。<br>\
                  您理解并同意：若您存在以上行为智能演讲教练有权采取相应措施（包括但不限于未经通知即关闭服务、要求您赔偿智能演讲教练因此遭受的全部损失以及提请司法机关追究法律责任）追究您的相关责任。<br>\
                  4.4 会员账号注销：除智能演讲教练按照协议或公告及相关法律法规注销用户的会员账号外，您可以通过在线申请或联系智能演讲教练的客服等方式注销会员账号。您确认账号一旦注销，您将无法继续使用会员服务。且您曾通过该账号使用相关服务所涉及的所有内容、信息、数据、记录将会被删除或匿名化处理；除法律法规另有规定，您也无法再检索、访问、获取、继续使用和找回前述内容、信息、数据、记录，也无权要求智能演讲教练找回。<br>\
                  五、会员行为规范<br>\
                  5.1 您在使用本服务时不得利用本服务从事以下行为，包括但不限于：<br>\
                  （1）发布、传送、传播、储存违反国家法律、危害国家安全统一、社会稳定、公序良俗、社会公德以及侮辱、诽谤、淫秽、暴力的内容；<br>\
                  （2）发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；<br>\
                  （3）虚构事实、隐瞒真相以误导、欺骗他人；<br>\
                  （4）发表、传送、传播广告信息及垃圾信息；<br>\
                  （5）从事其他违反法律法规（包括但不限于《中华人民共和国著作权法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《互联网电子公告服务管理规定》、《信息网络传播权保护条例》、《网络安全法》等有关计算机及互联网规定的法律、法规）、政策及公序良俗、社会公德等的行为。<br>\
                  5.2 本服务仅供您个人使用，除非经智能演讲教练书面许可，您不得进行以下行为：<br>\
                  （1）通过任何方式搜集本服务中其他用户的用户名、电子邮件等相关信息，并以发送垃圾邮件、连锁邮件、垃圾短信、即时消息等方式干扰、骚扰其他用户；<br>\
                  （2）通过本服务发布包含广告、宣传、促销等内容的信息；<br>\
                  （3）将本服务再次许可他人使用；<br>\
                  （4）其他未经智能演讲教练书面许可的行为。<br>\
                  5.3 服务的变更、中止或终止<br>\
                  5.3.1 本服务的中止或终止包含如下情况：<br>\
                  （1）您主动中止或终止，包括但不限于会员到期未进行续费等；<br>\
                  （2）因为您的违约行为，智能演讲教练主动中止或终止服务的；<br>\
                  （3）因国家或相关政府监管部门要求或发生不可抗力事件时，智能演讲教练中止或终止服务的；<br>\
                  （4）其他根据法律法规应中止或终止服务的。<br>\
                  5.3.2 您充分了解并同意，由于互联网服务的特殊性，智能演讲教练可能会按照相关法律法规、双方约定或在其他必要时，修改、变更、中止或终止向您提供部分或全部服务，届时，智能演讲教练会依法保护您的合法权益。且您同意，依本服务协议规定提供之服务，无需进行事先通知即可变更、中止或终止，针对变更服务，如果您继续使用，即视为您同意该变更。本条记载的情形下不视为智能演讲教练违约，智能演讲教练无需向您承担任何法律责任。<br>\
                  5.3.3 智能演讲教练未及时行使或延迟行使其在本协议项下的权利并不构成对这些权利的放弃，而单一或部分行使其在本协议项下的任何权利并不排斥其任何其他权利的行使。<br>\
                  六、违约责任<br>\
                  6.1 违约的处理<br>\
                  如果智能演讲教练发现或收到他人举报您有任何违反本协议的行为，智能演讲教练有权依法进行独立判断并采取技术手段予以删除、屏蔽或断开相关的信息。同时，智能演讲教练有权视您的行为性质，对您采取包括但不限于中止或终止部分或全部本服务、中止或终止您对智能演讲教练会员使用、追究您法律责任等措施，智能演讲教练也无需向您退还任何费用，而由此给您带来的损失，由您自行承担，造成智能演讲教练损失的，您也应予以赔偿（包括但不限于直接经济损失、商誉损失及对外支付的赔偿金、和解费、律师费、诉讼费等合理费用），并且在智能演讲教练要求的时限内支付完毕。<br>\
                  6.2 对第三方损害的处理<br>\
                  您有违反本协议约定的任何行为，导致任何第三方损害的，您应当独立承担责任；智能演讲教练因此遭受损失的，您也应当进行赔偿。<br>\
                  七、其他<br>\
                  7.1 协议的生效<br>\
                  您使用本服务即视为您已阅读并同意受本协议的约束。除本协议另有约定情况外，本协议自您选择接受或使用本服务后生效，直至终止本服务时止。<br>\
                  7.2 适用法律<br>\
                  本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。<br>\
                  7.3 争议解决<br>\
                  若您和【智能演讲教练】之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交有管辖权的人民法院管辖。<br>\
                  7.4 条款效力<br>\
                  本协议条款无论因何种原因部分无效或不可执行，不影响其余条款的效力及执行，对双方具有约束力。<br>\
                  （正文完）<br>\
                  智能演讲教练信息技术（上海）有限公司"
    }else if(type == 4){
      this.title = 'Speakio Premium Subscription Agreement';
      document.title = 'Speakio Premium Subscription Agreement';
      this.text = 'Effective Date: April 28, 2026';
      this.txt = "Welcome to Speakio Premium! This Premium Subscription Agreement (the 'Agreement') is a legal agreement between you ('User' or 'you') and Speakio2026 ('Speakio,' 'we,' 'us,' or 'our') governing your purchase and use of our paid subscription services (the 'Premium Service').\
                  By purchasing, activating, or using a Speakio Premium subscription, you agree to be bound by this Agreement, which supplements our general Terms of Service.<br>\
                  <strong>1. Description of Premium Service</strong><br/>\
                  Speakio Premium (e.g., Speakio Pro) provides advanced AI-powered public speaking coaching features, which may include but are not limited to: unlimited AI scriptwriting, full-length multi-modal (visual/audio) speech diagnosis, premium scenario libraries, and ad-free priority processing. The specific features are subject to the description on the purchase page within the App.\
                  <br/>\
                  <br/>\
                  <strong>2. Subscription Plans & Billing</strong><br/>\
                  <strong>Plan Options:</strong><br/>\
                  We offer various subscription periods, such as Weekly, Monthly, and Annual plans. The price and duration of each plan are displayed on the purchase screen prior to payment.\
                  <br/>\
                  <br/>\
                  <strong>Payment Processing: </strong><br/>\
                  All payments are securely processed through the billing system of the applicable app store (Apple App Store for iOS devices or Google Play Store for Android devices). We do not directly collect or store your credit card information.\
                  <br/>\
                  <br/>\
                  <strong>Automatic Renewal: Your subscription will automatically renew at the end of each billing cycle unless you cancel it. </strong><br/>\
                  The renewal charge will be applied to your Apple ID or Google Play account within 24 hours prior to the end of the current subscription period.<br/>\
                  <br/>\
                  <br/>\
                  <strong>3. Free Trials</strong><br/>\
                  <br/>\
                  We may offer a free trial period for certain Premium plans.<br/>\
                  <br/>\
                  <strong>If you do not cancel the subscription at least 24 hours before the free trial ends, you will automatically be charged</strong> the applicable subscription fee for the plan you selected.<br/>\
                  <br/>\
                  Any unused portion of a free trial period will be forfeited when you purchase a premium subscription.<br/>\
                  <br/>\
                  <br/>\
                  <strong>4. Cancellation Policy</strong><br/>\
                  <br/>\
                  <strong>How to Cancel:</strong> You can cancel your automatic renewal at any time. Because your payment is managed by Apple or Google, <strong>deleting your Speakio account or uninstalling the app will NOT cancel your subscription.</strong> You must cancel directly through your device's subscription settings:<br/>\
                  <br/>\
                  <strong>For iOS Users (Apple App Store):</strong> Go to your iPhone Settings > Tap your name (Apple ID) > Tap Subscriptions > Select Speakio > Tap Cancel Subscription.<br/>\
                  <br/>\
                  <strong>For Android Users (Google Play Store):</strong>  Open the Google Play Store app > Tap your Profile icon > Tap Payments & subscriptions > Tap Subscriptions > Select Speakio > Tap Cancel subscription.<br/>\
                  <br/>\
                  <strong>Post-Cancellation: </strong> If you cancel, your Premium Service will remain active until the end of your current paid billing cycle. We do not offer prorated refunds for mid-cycle cancellations. \
                  <br/>\
                  <br/>\
                  <strong>5. Refunds</strong><br/>\
                  <br/>\
                  All subscription payments are handled exclusively by Apple or Google, and their respective refund policies apply:<br/>\
                  <br/>\
                  <strong>Apple (iOS): </strong>Apple manages all billing and refunds for iOS purchases directly. We cannot issue refunds on their behalf. You must request a refund through Apple's 'Report a Problem' page.<br/>\
                  <br/>\
                  <strong>Google (Android):</strong>Refunds for Android purchases are handled in accordance with Google Play's refund policies. You may request a refund directly through Google Play Customer Support.<br/>\
                  <br/>\
                  <br/>\
                  <strong>6. Changes to Pricing and Plans</strong><br/>\
                  <br/>\
                  We reserve the right to modify our subscription plans or adjust pricing at any time. Any price changes will only apply to your next billing cycle. We or the respective app store will notify you of any price increases in advance, giving you the opportunity to cancel before the new price takes effect.<br/>\
                  <br/>\
                  <br/>\
                  <strong>7. Account Restrictions</strong><br/>\
                  <br/>\
                  Premium subscriptions are for personal use only. You may not share your login credentials, resell, or distribute the Premium Service to third parties. We reserve the right to suspend or terminate your account without refund if we detect abusive behavior or unauthorized sharing.\
                  <br/>\
                  <br/>\
                  <strong>8. Contact Us</strong><br/>\
                  <br/>\
                  If you have any questions or issues regarding your Premium subscription, please contact our support team at:\
                  <br/>\
                  <br/>\
                  <strong>Email: </strong>zentimewise2@gmail.com<br/>\
                  ";
    }else if(type == 5 ){
      this.title = '第三方信息共享清单';
      document.title = '第三方信息共享清单';
      this.text = '更新日期2025.4';
      this.txt = "1.为保障珍时相关功能的实现与应用安全稳定的运行，我们可能会接入由合作方提供的软件开发包（SDK）、应用程序接口（API）、应用程序插件代码或通过其他合作方式，以实现相关目的。<br>\
                  2.我们会对获取信息的合作方的代码进行严格的安全监测，以保护数据安全。<br>\
                  3.我们对接入的相关合作方在目录中列明<br>\
                  4.请注意，合作方的代码可能因为其版本升级、策略调整原因导致数据处理类型存在一定变化，请以其公示的官方说明为准。<br>\
<br>\
                  一、第三方SDK目录<br>\
<br>\
                  Alipay（支付宝） SDK<br>\
                  共享方式：SDK本机采集<br>\
                  使用目的：帮助用户在应用内使用支付宝<br>\
                  使用场景：在用户使用支付宝支付时使用<br>\
                  运营方：支付宝（中国）网络技术有限公司<br>\
                  收集个人信息类型：设备信息、网络设备硬件地址，网络信息，读取存储（相册，媒体和其他文件）权限，读取手机状态<br>\
                  隐私权政策链接：https://opendocs.alipay.com/open/54<br>\
<br>\
                  友盟统计分析SDK<br>\
                  共享方式：SDK本机采集<br>\
                  使用目的：进行APP运营统计与分析K<br>\
                  使用场景：通过友盟统计收集个移动平台运营数据分析K<br>\
                  运营方：友盟同欣（北京）科技有限公司，北京锐讯灵通科技有限公司K<br>\
                  收集个人信息类型：设备信息（IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID）、位置信息、网络信息。读取存储（相册，媒体和其他文件）权限K<br>\
                  隐私权政策链接：https://www.umeng.com/page/policyK<br>\
<br>\
                  微信 SDK<br>\
                  共享方式：SDK本机采集<br>\
                  使用目的：支持微信登录，微信分享，微信支付<br>\
                  使用场景：使用微信授权登录场景，微信分享和支付场景<br>\
                  运营方：深圳市腾讯计算机系统有限公司<br>\
                  收集个人信息类型：设备信息、网络设备硬件地址，网络信息，读取存储（相册，媒体和其他文件）权限，读取手机状态<br>\
                  隐私权政策链接：https://open.weixin.qq.com/cgj-bin/frame?t=news/protocol_developer_tmpl<br>\
<br>\
                  华为推送<br>\
                  运营方：华为软件技术有限公司 <br>\
                  功能：用于向华为手机用户推送消息 <br>\
                  收集个人信息类型: 设备信息（AndroidID）、运营商类型、本应用运行中的进程<br>\
                  隐私政策链接：https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177<br>\
<br>\
                  小米推送<br>\
                  运营方：北京小米移动软件有限公司 <br>\
                  功能：用于向小米手机用户推送消息 <br>\
                  收集个人信息类型：设备信息（AndroidID、OAID）、本应用运行中的进程 <br>\
                  隐私政策链接：https://dev.mi.com/console/doc/detail?pId=1822<br>\
<br>\
                  VIVO推送<br>\
                  运营方：维沃移动通信有限公司 <br>\
                  功能：用于向VIVO手机用户推送消息 <br>\
                  收集个人信息类型：本应用运行中的进程 <br>\
                  隐私政策链接：https://dev.vivo.com.cn/documentCenter/doc/652<br>\
<br>\
                  支付宝<br>\
                  运营方：支付宝（中国）网络技术有限公司 <br>\
                  功能：可帮助用户完成付款、提供安全认证服务 <br>\
                  收集个人信息类型：设备信息（AndroidID）、蓝牙的mac地址、位置信息、剪切板信息、运营商类型、本应用运行中的进程 <br>\
                  隐私政策链接：https://render.alipay.com/p/c/k2cx0tg8<br>\
<br>\
                  高德地图<br>\
                  运营方：高德软件有限公司 <br>\
                  功能：帮助用户在发布信息时定位位置 <br>\
                  收集个人信息类型：位置信息（经纬度、精确位置、粗略位置）、设备信息【如IP 地址、GNSS信息、WiFi状态、WiFi参数、WiFi列表、基站信息、信号强度的信息、蓝牙信息、传感器信息（矢量、加速度、压力、方向、地磁）、设备信号强度信息】、设备标识信息（ OAID、IDFA）、当前应用信息（应用名、应用版本号）、设备参数及系统信息（系统属性、设备型号、操作系统）<br>\
                  隐私政策链接：https://lbs.amap.com/pages/privacy_no_device_id<br>\
<br>\
                  魅族推送<br>\
                  运营方：珠海市魅族通讯设备有限公司 <br>\
                  功能：用于向魅族手机用户推送消息 <br>\
                  收集个人信息类型：运营商类型、本应用运行中的进程<br>\
                  隐私政策链接：http://static.meizu.com/resources/term/privacy8.html<br>\
<br>\
                  新浪微博sso授权 <br>\
                  运营方：北京微梦创科网络技术有限公司<br>\
                  功能：用于帮助用户进行授权登录及将信息分享至微博<br>\
                  收集个人信息类型：本应用运行中的进程<br>\
                  隐私政策链接：https://weibo.com/signup/v5/privacy<br>\
<br>\
                  阿里安全<br>\
                  运营方：杭州橙盾信息科技有限公司<br>\
                  功能：用于App运行、网络请求、账号注册及登录等安全防护。为了判断模拟点击攻击，采集设备传感器信息感知用户手机震动状态。<br>\
                  收集个人信息类型：IDFA、OAID、操作系统、设备传感器（设备加速器，如重力感应器）<br>\
                  隐私权政策链接：https://terms.alicdn.com/legal-agreement/terms/suit_bu1_alibaba_group/suit_bu1_alibaba_group202101081802_49105.html<br>\
<br>\
                  号码认证 <br>\
                  运营方：阿里巴巴云计算（北京）有限公司<br>\
                  功能：实现本机号码一键登录和认证 <br>\
                  收集个人信息类型：网络类型、切换wifi和蜂窝网络通道、设备信息（含IP地址、设备制造商、设备型号、手机操作系统、SIM卡信息SIM State）。<br>\
                  隐私权政策链接：https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112211045_86198.html<br>\
                  号码认证SDK服务集成三大运营商用户本机号码认证及一键登录及技术服务SDK，三大运营商如何处理用户个人信息，详见如下及隐私政策。<br>\
<br>\
                  中国移动 <br>\
                  运营主体:中国移动通信集团有限公司<br>\
                  功能:识别用户的手机号码快速登录，以及查询、分析和风险控制。<br>\
                  收集个人信息类型:网络类型、网络地址、运营商类型、本机号码信息、SIM卡状态、手机设备类型、手机操作系统、硬件厂商。<br>\
                  隐私权政策链接:https://wap.cmpassport.com/resources/html/contract2.html<br>\
<br>\
                  中国联通 <br>\
                  运营主体:中国联合网络通信集团有限公司 <br>\
                  功能:识别用户的手机号码快速登录，以及实现业务风控<br>\
                  收集个人信息类型:网络类型、网络地址、运营商类型、本机手机号、手机设备类型、手机操作系统、硬件厂商。<br>\
                  隐私政策链接:<br>\
                  https://opencloud.wostore.cn/authz/resource/html/disclaimer.html?spm=a2c4g.11186623.0.0.41f1633eHxMLkQ&fromsdk=true<br>\
<br>\
                  中国电信<br>\
                  运营主体:中国电信集团有限公司 <br>\
                  功能:识别用户的手机号码快速登录，以及实现业务风控<br>\
                  收集个人信息类型:网络IP地址、网络类型、注册手机号码、本机号码、国际移动用户标识码、应用进程信息、网络连接类型、网络状态信息、网络地址、运营商类型、手机设备类型、手机设备厂商、手机操作系统类型及版本。<br>\
                  隐私政策链接:<br>\
                  https://e.189.cn/sdk/agreement/detail.do?spm=a2c4g.11186623.0.0.41f1633eHxMLkQ&appKey=E_189&hidetop=true&returnUrl=<br>\
<br>\
                  银联云闪付SDK<br>\
                  运营方：中国银联股份有限公司<br>\
                  功能：帮助用户使用云闪付支付渠道完成付款<br>\
                  收集个人信息类型：设备型号、App安装信息（只读云闪付App）<br>\
                  隐私政策链接：https://wallet.95516.com/s/wl/WebAPP/helpAgree/page/agreement/regPrivacy.html?cntryCode=86<br>\
<br>\
                  数典UT SDK<br>\
                  运营方：杭州数典科技有限公司<br>\
                  功能：统计分析<br>\
                  收集个人信息类型：设备信息（IDFA、AndroidID、OAID、GAID、client IP）、UT SDK存储于SD卡的配置信息<br>\
                  隐私权政策链接：https://terms.alicdn.com/legal-agreement/terms/suit_bu1_alibaba_group/suit_bu1_alibaba_group202110291512_80686.html";
    } else if(type == 6 ){
      this.title = 'Speakio Account & Data Deletion Request';
      document.title = 'Speakio Account & Data Deletion Request';
      this.text = '';
      this.txt = "If you wish to completely delete your Speakio account and erase all associated personal data from our servers, you do not need to have the app installed. You can easily request account deletion by following the steps below:\
       <br>\
       <br>\
                  <span class='blod'>How to Request Deletion:</span>\
       <br>\
       <br>\
                  Send an email to our support team at <span class='blod'>zentimewise2@gmail.com.</span>\
       <br>\
       <br>\
                  Please send the email from the exact email address associated with your Speakio account to help us verify your identity.\
       <br>\
       <br>\
                  Use the subject line: <span class='blod'>'Account Deletion Request'</span>.\
       <br>\
       <br>\
                  In the body of the email, simply state that you wish to permanently delete your Speakio account and all related data.\
       <br>\
                  <span class='blod'>What Happens Next (Data Deletion Policy):</span>\
       <br>\
       <br>\
                  Upon receiving your request, our team will process the deletion within <span class='blod'>7 to 15 business days</span>.\
       <br>\
       <br>\
                  <span class='blod'>Data Erased: </span>Your account profile, email address, practice history, AI diagnostic reports, and any permanently stored audio/video recordings will be irreversibly erased from our active databases.\
       <br>\
       <br>\
                  <span class='blod'>Data Retained: </span>We may only retain minimal transaction data strictly required by law for financial and billing compliance.\
      ";
    }
    this.font_resize();
  },
  methods: {
    font_resize(){
      var size=document.documentElement.clientWidth / 750 * 100;
      document.querySelector('html').style.fontSize=size + 'px';
    }
  }  
};
</script>
<style scoped>
  .contentBox{
    font-size: .2rem;
    color: #333;
    box-sizing: border-box;
    padding: .1rem .2rem;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .contentBox .title{
    font-size: .4rem;
    color: #333;
    font-weight: bold;
    margin: .2rem 0;
  }

  .contentBox .text{
    font-size: .3rem;
    color: #333;
    font-weight: bold;
    margin: 0 0 .2rem;
  }

  .contentBox>>> .blod{
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/mobile/agreement.vue